module.exports = __webpack_public_path__ + "split.f7b99a.svg";